import { useEffect } from 'react';
import { createOnboardingGitOauthModalOptions } from 'modals/modal-options-factory';

const AddProvider = ({ gitSensorAuthorizations, toggleModal }) => {
  useEffect(() => {
    if (!gitSensorAuthorizations.length) {
      toggleModal(
        createOnboardingGitOauthModalOptions({
          toggleModal
        })
      );
    }
  }, []);

  return null;
};

export default AddProvider;
